import { z } from 'zod';
import { ApplicationStatusSchema, } from "./applications.dto.js";
import { ApplicationSearchFiltersSchema, } from "./find-applications-by-facility.dto.js";
import { createPaginatedQuerySchema, } from "../../../../common/types/pagination.js";
// === GET /staff/applications/cards ===
// Request validation schema
export const ListApplicationCardsRequestDTOSchema = z.object({
    query: ApplicationSearchFiltersSchema.extend({
        limitPerStatus: z.coerce.number().int().min(1).max(20),
    }),
});
// === GET /staff/applications/cards/:status ===
// Request validation schema
export const ListApplicationCardsByStatusRequestDTOSchema = z.object({
    params: z.object({
        status: ApplicationStatusSchema,
    }),
    query: createPaginatedQuerySchema(ApplicationSearchFiltersSchema),
});
//# sourceMappingURL=list-application-cards.dto.js.map